import { BsArrowRight } from "react-icons/bs";
import { projects } from "../config";
import { Button, PortfolioItem } from "./parts";

const Portfolio = () => {
  return (
    <section id="portfolio" className="py-24 md:py-32 text-center">
      <div className="flex justify-between items-center mb-7 px-5 md:px-32">
        <div>
          <h1 className="text-4xl font-medium mb-3">
            See my latest <span className="text-primary">Project</span>
          </h1>
          <p className="text-lg font-light text-gray-300">Check out some of the projects I've had</p>
        </div>
        <Button
          link
          to="/portfolio"
          color="bg-primary"
          textColor="text-white"
          className="hidden md:flex items-center gap-3"
        >
            See all <BsArrowRight size={34} />
        </Button>
      </div>
      <div className="overflow-x-auto no-scrollbar">
        <div className="flex gap-5 px-5 md:px-32 w-max">
          {projects.filter(p => p.featured).reverse().map((project) => (
            <PortfolioItem key={project.id} data={project} isRounded width="w-80" />
          ))}
        </div>
      </div>
      <Button
        link
        to="/portfolio"
        color="bg-primary"
        textColor="text-white"
        className="flex md:hidden items-center w-max mx-auto gap-3 mt-8"
      >
          See all <BsArrowRight size={34} />
      </Button>
    </section>
  );
};

export default Portfolio;
